import { Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import ClientCard from "components/ui/ClientFlow/ClientCard";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";
import apiClient from "lib/api-client";
import React from "react";
import { useParams } from "react-router-dom";
import { formatCurrency } from "utils/formatCurrency";

const fetchDuesAndLedger = async (clientCode) => {
  const { data } = await apiClient.get(
    `/api/v9/myBinnys/getDuesAndLedger?clientCode=${clientCode}`
  );
  return data?.data?.data;
};

function ClientsDueAndLedger() {

  const { clientId } = useParams();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["duesAndLedger", clientId],
    queryFn: () => fetchDuesAndLedger(clientId),
    enabled: !!clientId,
  });

  if (isLoading) return <LoadingSmallCard count={2} height={102} />;
  if (isError || !data) return <div>Error loading data</div>;

  const {
    totalDues,
    totalDuesClosingBalance,
    totalDuesBalance,
    totalLedger,
    totalLedgerClosingDebit,
    totalLedgerClosingCredit,
    totalUnfixWeight
  } = data;

  const cardData = [
    {
      name: "Dues",
      count: totalDues,
      icon: "Dues",
      amount1: formatCurrency(totalDuesClosingBalance),
      amount2: formatCurrency(totalDuesBalance),
      weight:totalUnfixWeight,
    },
    {
      name: "Ledger",
      count: totalLedger,
      icon: "Ledger",
      amount2: formatCurrency(totalLedgerClosingDebit || totalLedgerClosingCredit),
      ledgerColor: totalLedgerClosingDebit > 0 ? "#50C878" : "#E77B7B",
    },
  ];

  return (
    <div style={{ color: "yellow" }}>
      <Grid container spacing={2} marginTop={3} marginLeft={1} sx={{ display: "flex", gap: "2rem" }}>
        {cardData.length &&
          cardData.map((data) => {
            return (
              <Grid item sx={{ padding: "0px !important" }}>
                <ClientCard data={data} showLine={true} page="purchase" />
              </Grid>
            );
          })}
      </Grid>
    </div>
  );
}

export default ClientsDueAndLedger;
